<template>
  <div :class="['CartItemQuantifier', displayQuantifier ? 'QuantifierGift': '']">
    <span v-if="!displayQuantifier">{{ quantity }}</span>
    <span v-else>___</span>

    <div v-if="!displayQuantifier" class="Quantifiers">
      <div @click="$emit('up')">^</div>
      <div class="Reversed" @click="$emit('down')">^</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CartItemQuantifier',
  props: {
    quantity: {
      type: Number,
      required: false,
      default: 0
    },
    displayQuantifier: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.CartItemQuantifier {
  color: $primary;
  padding: 10px 15px;
  font-size: 12px;

  &:not(.QuantifierGift) {
    border: 1px solid $primary;
    user-select: none;
  }

  &.QuantifierGift {
    padding-bottom: 20px;
  }

  * {
    vertical-align: middle;
  }

  .Quantifiers {
    display: inline-block;
    margin-left: 10px;

    div {
      cursor: pointer;
    }

    .Reversed {
      transform: rotate(180deg);
    }
  }
}
</style>
